export const tr = {
    cases: 'Örnek durumlar',
    help: 'Yardım',
    'online-courses': 'Çevrimiçi kurslar',
    site: 'Site',
    study: 'Courses'
};
